import { isOpportunityIngestEnabled } from '@yeshuman/sdk'
import type { JobBrowseFilters } from '../job-browse-filters'

/** Filters that only apply to managed (TalentCo) job rows — not marketplace ingest listings. */
export function hasManagedOnlyJobBrowseFilters(filters: JobBrowseFilters): boolean {
  return (
    filters.selectedSkills.length > 0 ||
    filters.work_mode.length > 0 ||
    filters.employment_type.length > 0
  )
}

export function marketplaceSourceInScope(filters: JobBrowseFilters): boolean {
  if (!isOpportunityIngestEnabled()) return false
  if (filters.source.length === 0) return true
  return filters.source.includes('marketplace')
}

export function shouldShowCandidateJobFilterCoverageHint(filters: JobBrowseFilters): boolean {
  return hasManagedOnlyJobBrowseFilters(filters) && marketplaceSourceInScope(filters)
}

export const CANDIDATE_JOB_FILTER_COVERAGE_HINT =
  'Skills, work mode, and employment filters apply to TalentCo listings only. Marketplace roles may be hidden when these filters are active.'
